export default "__VITE_ASSET__CyGjyQ15__"